import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 py-10 bg-darkGray border-t-4 border-primary/30" data-id="element-57">
      <div className="max-w-6xl mx-auto" data-id="element-58">
        <div className="text-center space-y-5" data-id="element-59">
          <p className="text-textGray text-[15px] md:text-[17px] font-inter leading-relaxed" data-id="element-60">
            © 2025 Néstor León · Studio Web VIP Partner · Emprendedor Digital
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-[14px] md:text-[15px] font-inter" data-id="element-61">
            <a href="#privacy" className="text-textGray hover:text-primary transition-colors font-medium" data-id="element-62">
              Política de Privacidad
            </a>
            <span className="text-textGray hidden sm:inline" data-id="element-63">|</span>
            <a href="#terms" className="text-textGray hover:text-primary transition-colors font-medium" data-id="element-64">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}